const shortNameMap: Record<string, string> = {
  lso: 'LSO',
  ups: 'UPS',
  fedex: 'Fedex',
  uspsdirect: 'USPS Direct',
  upsmi: 'UPS MI',
  usps: 'USPS',
};

export function getCarrierShortName(carrierId: string, carrier?: { name?: string }) {
  return shortNameMap[carrierId] || carrier?.name || carrierId.toUpperCase();
}
